import React from 'react'
import { View } from 'react-native'
import { SelectWithData } from './SelectWithData'
import _ from 'lodash'

export const FieldPicker = React.forwardRef((props, ref) => {
  const { fieldList, additionalOptions, filterFunction = (f) => f } = props

  const { onFieldSelected } = props

  const fieldsWithAdditional = _.filter(
    [...(fieldList ?? []), ...(additionalOptions ?? [])],
    filterFunction
  )

  return (
    <View>
      <SelectWithData
        {...props}
        dataRows={fieldsWithAdditional}
        labelField={'title'}
        label2Field={'id'}
        keyFieldResolver={(obj) => {
          return obj?.id
        }}
        valueField="title"
        keyField="id"
        objectIsValue={true}
        onChangeText={onFieldSelected}
      />
    </View>
  )
})

FieldPicker.defaultProps = {
  additionalOptions: []
}
